module.exports = __webpack_public_path__ + "img/img_clients15.e398e752.jpg";